/** Вкладки профілю дилера — у порядку макета Paper «Admin — Dealer profile». */
export const PROFILE_TABS = ['overview', 'bids', 'vehicles', 'invoices', 'money', 'account'] as const;
export type ProfileTab = (typeof PROFILE_TABS)[number];

/**
 * Стан профілю — в адресі (§11 гайду): посилання на «гроші дилера, сторінка 3»
 * можна надіслати колезі, а «назад» повертає на попередню вкладку.
 * `page` — основний список вкладки; `topUpsPage` — другий список у Money.
 */
export interface ProfileSearch {
	tab?: ProfileTab;
	page?: number;
	topUpsPage?: number;
}

const pageOf = (value: unknown): number | undefined => {
	const page = Number(value);
	return Number.isInteger(page) && page > 1 ? page : undefined;
};

export function validateProfileSearch(raw: Record<string, unknown>): ProfileSearch {
	const tab = PROFILE_TABS.find((t) => t === raw.tab);
	return { tab: tab === 'overview' ? undefined : tab, page: pageOf(raw.page), topUpsPage: pageOf(raw.topUpsPage) };
}
